import React from 'react';

import moment from 'moment';

export default ({ date }) => {
  const formattedDate = moment(date).format('MM/DD/YYYY');
  return (
    <span
      style={{
        color: '#999999',
        fontSize: '14px',
        lineHeight: '16px',
      }}>
      {moment(date).isValid() ? formattedDate : 'NA'}
    </span>
  );
};
